import { connect } from 'react-redux'
import OBS3StorageInputs from './OBSS3Inputs.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    accessKey: state.analyticsExport.exportApiConfig.obsS3.accessKey,
    secretAccessKey: state.analyticsExport.exportApiConfig.obsS3.secretAccessKey,
    region: state.analyticsExport.exportApiConfig.obsS3.region,
    endpoint: state.analyticsExport.exportApiConfig.obsS3.endpoint,
    bucketName: state.analyticsExport.exportApiConfig.obsS3.bucketName,
    isFetching: state.analyticsExport.exportApiConfig.isFetchingExportApiConfig,
    isSaving: state.analyticsExport.exportApiConfig.isFetchingExportApiConfig
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateExportApiConfig: key => e => dispatch(Actions.updateExportApiOBSConfig(key, e.target.value))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OBS3StorageInputs)
